import { apiRequest } from "../api";

export interface PendingPortalUserRow {
  _id: string;
  name: string;
  email: string;
  status: string;
  clientId?: string;
  organizationId?: string;
  createdAt?: string;
  clientName?: string;
  clientEmail?: string;
}

export const pendingPortalUsersService = {
  async list(params?: { page?: number; limit?: number }) {
    return apiRequest<{ result: PendingPortalUserRow[]; total: number; qtdPages: number }>({
      loaderKey: "pendingPortalUsers",
      method: "get",
      url: "/app/clients/pending-portal-users",
      params,
    });
  },

  async approve(clientUserId: string) {
    return apiRequest<{ msg: string; result: unknown }>({
      loaderKey: "approvePortalUser",
      method: "post",
      url: `/app/clients/pending-portal-users/${clientUserId}/approve`,
      data: {},
    });
  },

  async reject(clientUserId: string) {
    return apiRequest<{ msg: string }>({
      loaderKey: "rejectPortalUser",
      method: "post",
      url: `/app/clients/pending-portal-users/${clientUserId}/reject`,
      data: {},
    });
  },
};
